"use client";

import { apiClient } from "@shared/lib/api-client";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { toast } from "sonner";
import type { VideoHistoryItem } from "./types";
import { GENERATION_HISTORY_QUERY_KEY } from "./types";

/** 视频收藏是整条记录级别的。两个生成页的 history 都要用，状态放这儿免得各写一份。 */
export function useVideoFavorite() {
	const t = useTranslations("assets");
	const queryClient = useQueryClient();
	// 乐观状态，key 是视频 id
	const [overrides, setOverrides] = useState<Record<string, boolean>>({});

	const isFavorite = (item: VideoHistoryItem) =>
		overrides[item.id] ?? item.favorite;

	const toggleFavorite = async (item: VideoHistoryItem) => {
		const current = isFavorite(item);
		const next = !current;
		setOverrides((prev) => ({ ...prev, [item.id]: next }));

		try {
			const response = await apiClient["ai-video"][
				":taskId"
			].favorite.$patch({
				param: { taskId: item.id },
				json: { favorite: next },
			});
			if (!response.ok) {
				throw new Error("Failed to update favorite");
			}
			queryClient.invalidateQueries({
				queryKey: GENERATION_HISTORY_QUERY_KEY,
			});
		} catch (error) {
			setOverrides((prev) => ({ ...prev, [item.id]: current }));
			console.error("Error toggling video favorite:", error);
			toast.error(t("errors.favoriteFailed"));
		}
	};

	return { isFavorite, toggleFavorite };
}
